import React from 'react';
import Header from '@modules/common/components/Header';

import { ModalContent } from '@modules/common/components/BaseModal/ModalContent';
import { ModalActions } from '@modules/common/components/BaseModal/ModalActions';
import ErrorMessage from '@modules/common/components/banners/ErrorMessage';
import { Button } from '@modules/common/components/buttons/Button';
import { ModalHeader } from '@modules/common/components/BaseModal/ModalHeader';

import ActionButton from '../common/ActionButton';

type Props = {
  handleClose: () => void;
  deleting: boolean;
  handleDelete: () => void;
};

const DeleteUser = ({ handleClose, deleting, handleDelete }: Props) => {
  return (
    <>
      <ModalHeader>
        <Header icon="trash" content="Delete Profile" />
      </ModalHeader>
      <ModalContent>
        <ErrorMessage
          header="Are you sure you want to delete your profile?"
          list={[
            'You wont be able to use WMS services anymore.',
            'You will lose all your WMS configurations and layers.',
            'You will lose your subscription.',
            'This action is irreversible as deletion is permanent.',
          ]}
        />
      </ModalContent>
      <ModalActions>
        <Button icon="remove" onClick={handleClose} circular>
          Cancel
        </Button>
        <ActionButton icon="trash" color="red" circular onClick={handleDelete} loading={deleting}>
          Yes, delete profile
        </ActionButton>
      </ModalActions>
    </>
  );
};

export default React.memo(DeleteUser);
